import { render, staticRenderFns } from "./PDFDocumentViewFrame.vue?vue&type=template&id=738b0913&scoped=true"
import script from "./PDFDocumentViewFrame.vue?vue&type=script&lang=js"
export * from "./PDFDocumentViewFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b0913",
  null
  
)

export default component.exports